import { render, staticRenderFns } from "./ColorCellRenderer.vue?vue&type=template&id=1a4000fe&scoped=true&lang=pug&"
import script from "./ColorCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./ColorCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./ColorCellRenderer.vue?vue&type=style&index=0&id=1a4000fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4000fe",
  null
  
)

export default component.exports